type DateFormat = string;

/**
 * 
 * @param unixTimestamp 
 * @param format 
 * @returns requested format
 * Example usage: 
 * formatUnixTimestamp(1700000000, "YYYY/MM/DD"); -> "2023/11/14",
 * formatUnixTimestamp(1700000000, "YYYY/MM/DD hh:mm:ss A"); -> // "2023/11/14 05:13:20 PM",
 * formatUnixTimestamp(1700000000); -> // "2023/11/14 17:13:20"
 */
const formatUnixTimestamp = (
  unixTimestamp: number,
  format: DateFormat = "YYYY/MM/DD HH:mm:ss",
) => {
  const date = new Date(unixTimestamp * 1000);

  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Toronto",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  const parts = formatter.formatToParts(date).reduce<Record<string, string>>(
    (acc, part) => {
      acc[part.type] = part.value;
      return acc;
    },
    {}
  );

  const hour12 = parts.hour.padStart(2, "0");
  const hour24 = String(
    (parseInt(parts.hour, 10) % 12) + (parts.dayPeriod === "PM" ? 12 : 0)
  ).padStart(2, "0");

  const tokens: Record<string, string> = {
    YYYY: parts.year,
    MM: parts.month,
    DD: parts.day,
    HH: hour24,
    hh: hour12,
    mm: parts.minute,
    ss: parts.second,
    A: parts.dayPeriod,
  };

  return Object.entries(tokens).reduce(
    (result, [token, value]) => result.replaceAll(token, value),
    format
  );
}

export default formatUnixTimestamp;